import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
import { NavSectionProps } from '../type';
import { NavListRoot } from './NavList';
import { BRAND } from 'src/theme/palette';

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} role={'presentation'} />
))(({ theme }) => ({
  ...theme.typography.overline,
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 600,
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(1),
  paddingBottom: theme.spacing(0),
  marginBottom: theme.spacing(2),
  color: theme.palette.grey[500],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: theme.spacing(1.5),
    left: theme.spacing(2),
    right: theme.spacing(2),
    height: 1,
    backgroundColor: theme.palette.divider,
    opacity: 0.8,
  },
}));

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps) {
  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }} aria-label={group.subheader}>
          <ListSubheaderStyle
            sx={{
              ...(isCollapse && {
                opacity: 0,
              }),
            }}
          >
            {group.subheader}
          </ListSubheaderStyle>

          {group.items.map((list) => (
            <NavListRoot key={list.title + list.path} list={list} isCollapse={isCollapse} />
          ))}
        </List>
      ))}
    </Box>
  );
}
